function mainfunc() {
  window.addEventListener('load', function(){
    function myCardLinks(){
      const cards = Array.from(document.querySelectorAll(".link-card"));
      cards.forEach((linkCard) => {
        const mainLink = linkCard.querySelector(".main-link");
        const clickableElements = Array.from(linkCard.querySelectorAll("a")); //we are using 'a' here for simplicity but ideally you should put a class like 'clickable' on every clicable element inside card(a, button) and use that in query selector
        
        clickableElements.forEach((ele) =>
            ele.addEventListener("click", (e) => e.stopPropagation())
        );
        
        function handleClick(event) {
          const noTextSelected = !window.getSelection().toString();
            
          if (noTextSelected) {
            mainLink.click();
          }
        }
        
        linkCard.addEventListener("click", handleClick);
      });
    }
    setTimeout(myCardLinks, 1000);
  });

  

  function stopResponsiveTransition() {
    window.addEventListener('load', function(){
      const classes = document.body.classList;
      let timer = null;
      window.addEventListener('resize', function () {
        if (timer){
          clearTimeout(timer);
          timer = null;
        } else {
          classes.add('stop-transition');
        }
        timer = setTimeout(() => {
          classes.remove('stop-transition');
          timer = null;
        }, 100);
      });
    });
  }
  stopResponsiveTransition();

  function addArrow(){
    window.addEventListener('load', function(){
      var navButton = document.querySelector('.nav-button a');
	    navButton.innerHTML += '<i class="fa-solid fa-arrow-right"></i>';
    })
  }
  addArrow();

  function addSearch(){
    window.addEventListener('load', function(){
      var searchInput = document.querySelector('.sf-field-search');
      var magnifyingGlass = document.createElement("span");
	    magnifyingGlass.innerHTML = '<i class="fa-solid fa-magnifying-glass"></i>';
      if(searchInput){
	      searchInput.appendChild(magnifyingGlass);
      }
    })
  }

  addSearch();

  function addArrowSingleRecipe(){
    window.addEventListener('load', function(){
      var navButton = document.querySelector('.single-recipebank #back-btn span');
      if (navButton){
        navButton.innerHTML += '<i class="fa-solid fa-arrow-right"></i>';
      }
	    
    });
  }
  
  function addArrowResetButton(){
    window.addEventListener('load', function(){
      var resetButton = document.querySelector('.search-filter-reset');
      if (resetButton){
        resetButton.innerHTML += '<i class="fa-solid fa-arrow-right"></i>';
      }
    });
  }
  addArrowResetButton();

  function addArrowSubmitButton(){
    window.addEventListener('load', function(){
      var submitButton = document.querySelector('.sf-field-submit');
      if (submitButton){
        submitButton.innerHTML += '<i class="fa-solid fa-arrow-right"></i>';
      }
    });
  }
  addArrowSubmitButton();

  function modifyTranslate(){
    window.addEventListener('load', function(){
      var translate = document.querySelector('.gt_selector');
      translate.selectedIndex = 0;
    });
  }
  modifyTranslate();




  function addVideoOverlay(){
    window.addEventListener('load', function(){
      var videos = document.querySelectorAll('.video-overlay  .uabb-video');
      var videosSpan = document.createElement("div");
	    videosSpan.innerHTML = '<div class="button-outer"><span><i class="fa-solid fa-play"></i><span><div>';
      if(videos){

	      videos.forEach((video) => {
          video.appendChild(videosSpan);
        });
      }
    })
  }

  addVideoOverlay();




  window.addEventListener('load', function(){
  function toggleVideo({ currentTarget: wrapper }) {
    let video = wrapper.querySelector('.video-element');
    let playpause = wrapper.querySelector('.playpause');
    if (video.paused) {
      video.play();
      playpause.setAttribute('hidden', '');
    } else {
      video.pause();
      playpause.removeAttribute('hidden');
    }
  }
  
  document.querySelectorAll('.video-wrapper').forEach(wrapper => wrapper.addEventListener('click', toggleVideo));
});
  

}

export default mainfunc




